// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"412":"15bf5c3c","776":"bd4d4083","916":"8190878a","945":"01a223cc"}[chunkId] + ".chunk.css";
};